 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {stateToHTML} from 'draft-js-export-html'
import {commitMutation} from 'react-relay'

import JiraProjectId from '~/shared/gqlIds/JiraProjectId'

import splitDraftContent from '../utils/draftjs/splitDraftContent'
import getMeetingPathParams from '../utils/meetings/getMeetingPathParams'
import createProxyRecord from '../utils/relay/createProxyRecord'

import SendClientSideEvent from '../utils/SendClientSideEvent'

graphql`
  fragment CreateTaskIntegrationMutation_task on CreateTaskIntegrationPayload {
    task {
      ...IntegratedTaskContent_task
      integration {
        __typename
        ... on JiraIssue {
          cloudId
          cloudName
          url
          issueKey
          summary
          descriptionHTML
          projectKey
          project {
            name
          }
        }
        ... on _xGitHubIssue {
          bodyHTML
          title
          number
          repository {
            nameWithOwner
          }
        }
        ... on JiraServerIssue {
          descriptionHTML
          summary
        }
        ... on _xGitLabIssue {
          descriptionHtml
          title
          iid
          webPath
          webUrl
        }
        ... on AzureDevOpsWorkItem {
          __typename
          id
          teamProject
          title
          url
        }
        ...TaskIntegrationLinkIntegrationGitHub
        ...TaskIntegrationLinkIntegrationJira
        ...TaskIntegrationLinkIntegrationJiraServer
        ...TaskIntegrationLinkIntegrationGitLab
        ...TaskIntegrationLinkIntegrationAzure
      }
      updatedAt
      teamId
      userId
      id
      taskService
    }
  }
`

const mutation = graphql`
  mutation CreateTaskIntegrationMutation(
    $integrationProviderService: IntegrationProviderServiceEnum!
    $integrationRepoId: ID!
    $taskId: ID!
  ) {
    createTaskIntegration(
      integrationProviderService: $integrationProviderService
      integrationRepoId: $integrationRepoId
      taskId: $taskId
    ) {
      error {
        message
      }
      ...CreateTaskIntegrationMutation_task @relay(mask: false)
    }
  }
`

const jiraTaskIntegrationOptimisticUpdater = (
  store,
  variables
) => {
  const {integrationRepoId, taskId} = variables
  const {cloudId, projectKey} = JiraProjectId.split(integrationRepoId)
  const now = new Date()
  const task = store.get(taskId)
  if (!task) return
  const contentStr = task.getValue('content') 
  if (!contentStr) return
  const {title: summary, contentState} = splitDraftContent(contentStr)
  const descriptionHTML = stateToHTML(contentState)
  const optimisticIntegration = {
    summary,
    descriptionHTML,
    projectKey,
    cloudId,
    issueKey: '?',
    cloudName: '',
    updatedAt: now.toJSON()
  } 
  const integration = createProxyRecord(store, 'JiraIssue', optimisticIntegration)
  task.setLinkedRecord(integration, 'integration')
}

const githubTaskIntegrationOptimisitcUpdater = (
  store,
  variables
) => {
  const {integrationRepoId, taskId} = variables
  const now = new Date()
  const task = store.get(taskId)
  if (!task) return
  const integrationRepository = createProxyRecord(store, '_xGitHubRepository', {
    nameWithOwner: integrationRepoId
  })
  const contentStr = task.getValue('content') 
  if (!contentStr) return
  const {title, contentState} = splitDraftContent(contentStr)
  const bodyHTML = stateToHTML(contentState)
  const optimisticIntegration = {
    title,
    bodyHTML,
    number: 0,
    updatedAt: now.toJSON()
  } 
  const integration = createProxyRecord(store, '_xGitHubIssue', optimisticIntegration)
  integration.setLinkedRecord(integrationRepository, 'repository')
  task.setLinkedRecord(integration, 'integration')
}

const gitlabTaskIntegrationOptimisitcUpdater = (
  store,
  variables
) => {
  const {integrationRepoId: fullPath, taskId} = variables
  const now = new Date()
  const task = store.get(taskId)
  if (!task) return
  const integrationRepository = createProxyRecord(store, '_xGitLabProject', {
    fullPath
  })
  const contentStr = task.getValue('content') 
  if (!contentStr) return
  const {title, contentState} = splitDraftContent(contentStr)
  const descriptionHtml = stateToHTML(contentState)
  const webPath = `${fullPath}/-/issues/0`
  const optimisticIntegration = {
    title,
    descriptionHtml,
    iid: 0,
    webPath,
    webUrl: `https://gitlab.com/${webPath}`,
    updatedAt: now.toJSON()
  } 
  const integration = createProxyRecord(store, '_xGitLabIssue', optimisticIntegration)
  integration.setLinkedRecord(integrationRepository, 'repository')
  task.setLinkedRecord(integration, 'integration')
}

const jiraServerTaskIntegrationOptimisticUpdater = (
  store,
  variables
) => {
  const {taskId} = variables
  const now = new Date()
  const task = store.get(taskId)
  if (!task) return
  const contentStr = task.getValue('content') 
  if (!contentStr) return
  const {title: summary, contentState} = splitDraftContent(contentStr)
  const descriptionHTML = stateToHTML(contentState)
  const optimisticIntegration = {
    summary,
    descriptionHTML,
    issueKey: '?',
    updatedAt: now.toJSON()
  } 
  const integration = createProxyRecord(store, 'JiraServerIssue', optimisticIntegration)
  task.setLinkedRecord(integration, 'integration')
}

const azureTaskIntegrationOptimisitcUpdater = (
  store,
  variables
) => {
  const {integrationRepoId: teamProject, taskId} = variables
  const now = new Date()
  const task = store.get(taskId)
  if (!task) return
  const contentStr = task.getValue('content') 
  if (!contentStr) return
  const {title, contentState} = splitDraftContent(contentStr)
  const descriptionHTML = stateToHTML(contentState)
  const optimisticIntegration = {
    id: '?',
    title,
    descriptionHTML,
    teamProject,
    type: 'Issue',
    url: `https://dev.azure.com`,
    updatedAt: now.toJSON()
  } 
  const integration = createProxyRecord(store, 'AzureDevOpsWorkItem', optimisticIntegration)
  task.setLinkedRecord(integration, 'integration')
}

const CreateTaskIntegrationMutation = (
  atmosphere,
  variables,
  {onCompleted, onError}
) => {
  const {integrationProviderService} = variables

  return commitMutation(atmosphere, {
    mutation,
    variables,
    optimisticUpdater: (store) => {
      if (integrationProviderService === 'jira') {
        jiraTaskIntegrationOptimisticUpdater(store, variables)
      } else if (integrationProviderService === 'github') {
        githubTaskIntegrationOptimisitcUpdater(store, variables)
      } else if (integrationProviderService === 'jiraServer') {
        jiraServerTaskIntegrationOptimisticUpdater(store, variables)
      } else if (integrationProviderService === 'gitlab') {
        gitlabTaskIntegrationOptimisitcUpdater(store, variables)
      } else if (integrationProviderService === 'azureDevOps') {
        azureTaskIntegrationOptimisitcUpdater(store, variables)
      }
    },
    onCompleted: (data, errors) => {
      if (onCompleted) {
        onCompleted(data, errors)
      }
      const {meetingId} = getMeetingPathParams()
      const store = atmosphere.getStore()
      const meetingType = meetingId
        ? _optionalChain([(store.getSource().get(meetingId) ), 'optionalAccess', _ => _.meetingType])
        : undefined
      if (data.createTaskIntegration && !_optionalChain([data, 'optionalAccess', _2 => _2.createTaskIntegration, 'optionalAccess', _3 => _3.error])) {
        SendClientSideEvent(atmosphere, 'Task Published', {
          taskId: _optionalChain([data, 'access', _4 => _4.createTaskIntegration, 'access', _5 => _5.task, 'optionalAccess', _6 => _6.id]),
          teamId: _optionalChain([data, 'access', _7 => _7.createTaskIntegration, 'access', _8 => _8.task, 'optionalAccess', _9 => _9.teamId]),
          inMeeting: !!meetingId,
          meetingId,
          meetingType,
          service: _optionalChain([data, 'access', _10 => _10.createTaskIntegration, 'access', _11 => _11.task, 'optionalAccess', _12 => _12.taskService])
        })
      }
    },
    onError
  })
}

export default CreateTaskIntegrationMutation
